import api from "app/api";
import { ROLES } from "app/constants";
import useAccess from "features/profile/useAccess";
import { useEffect, useState } from "react";

export default function useInvoiceNeededCount() {
  const [count, setCount] = useState(0);
  const { hasRoles, hasPermissions } = useAccess();

  async function loadInvoiceNeededCount() {
    if (hasRoles(ROLES.PARTNER)) {
      return;
    }
    if (
      !hasPermissions("payment_transaction.menu") ||
      !hasPermissions([
        "payment_transaction.viewany",
        "payment_transaction.viewown",
      ])
    ) {
      return;
    }

    const { success, data, error } = await api.get(
      "/payment-transactions/invoice-needed-count",
    );
    if (success) {
      setCount(data?.count || 0);
    }
  }

  useEffect(() => {
    loadInvoiceNeededCount();
  }, []);

  return count;
}
